import { InjectionToken } from '@angular/core';
/**
 * @hidden
 */
export var TOUCH_ENABLED = new InjectionToken('dateinputs-touch-enabled');



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dateinputs/dist/es/touch-enabled.js
// module id = ../../../../@progress/kendo-angular-dateinputs/dist/es/touch-enabled.js
// module chunks = vendor